import { Badge } from "@mantine/core";

interface CaseStatusBadgeProps {
  statusName: string;
  isBlocked?: boolean;
}

export default function CaseStatusBadge({
  statusName,
  isBlocked,
}: CaseStatusBadgeProps) {
  // Determine color based on status name
  const getColor = () => {
    if (isBlocked) return "red";

    const status = statusName.toLowerCase();

    // Draft
    if (status.includes("received") || status.includes("new")) return "gray";
    if (status.includes("draft")) return "blue";

    // Grossing
    if (status.includes("grossing") || status.includes("gross")) return "cyan";
    if (status.includes("processing")) return "indigo";

    // Embedding
    if (status.includes("embedding")) return "blue";

    // Cutting & Staining
    if (status.includes("cutting")) return "violet";
    if (status.includes("staining")) return "grape";
    if (status.includes("scan")) return "teal";

    // Review & Sign-off
    if (status.includes("ready") && status.includes("review")) return "orange";
    if (status.includes("review")) return "yellow";
    if (status.includes("diagnosis")) return "lime";

    // Final stages
    if (status.includes("sign") || status.includes("signed")) return "teal";
    if (status.includes("complete") || status.includes("delivered"))
      return "green";

    return "gray";
  };

  const label = isBlocked ? `BLOCKED - ${statusName}` : statusName;

  return (
    <Badge
      color={getColor()}
      variant={isBlocked ? "filled" : "light"}
      size="sm"
      styles={{ label: { overflow: "visible", textOverflow: "unset" } }}
    >
      {label}
    </Badge>
  );
}
